// extracted by mini-css-extract-plugin
module.exports = {"applyButtonWrapper":"ApplyButton_applyButtonWrapper__bgVKv","applyButton":"ApplyButton_applyButton__C2Gmy"};